import { clone, onError } from '../../common/common';

// ------------------------------------
// Constants
// ------------------------------------
export const SET_ACTIVE_CHAT = 'SET_ACTIVE_CHAT';

// ------------------------------------
// Actions
// ------------------------------------

export const setActiveChat = chat => {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      dispatch({ type: SET_ACTIVE_CHAT, payload: { chat } });
      resolve();
    });
  };
};

// ------------------------------------
// Action Handlers
// ------------------------------------

const processSetActiveChat = (state, action) => {
  const { chat } = action.payload;
  const { chatSelectRoomOpen } = state;

  if (chat.active && chatSelectRoomOpen) return { ...state, chatSelectRoomOpen: false };
  if (chat.active) return state;

  const newState = clone(state);
  newState.messagesInitialized = false;
  newState.chatSelectRoomOpen = false;
  newState.chat = newState.chats.find(chatItr => chat.id === chatItr.id);
  newState.chats.forEach(chatItr => (chatItr.active = chat.id === chatItr.id));

  return newState;
};

export const CHAT_ACTIONS_ACTION_HANDLERS = {
  [SET_ACTIVE_CHAT]: processSetActiveChat,
};



// WEBPACK FOOTER //
// ./app/javascript/chat/modules/chat-actions.js